import { render, staticRenderFns } from "./r-currency-correction-panel.vue?vue&type=template&id=7b462ada"
import script from "./r-currency-correction-panel.vue?vue&type=script&lang=js"
export * from "./r-currency-correction-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b462ada')) {
      api.createRecord('7b462ada', component.options)
    } else {
      api.reload('7b462ada', component.options)
    }
    module.hot.accept("./r-currency-correction-panel.vue?vue&type=template&id=7b462ada", function () {
      api.rerender('7b462ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-correction-panel.vue"
export default component.exports